import normalize from 'json-api-normalizer'
import { coreApi } from '../api'

async function fetchData(applicationId) {
  const response = await coreApi.get(
    `/loan/auto-refi/bkf/applications/${applicationId}/requester`,
  )

  const normalizedData = normalize(response.data)

  return normalizedData
}

async function fetchPhoneNumber(applicationId) {
  const data = await fetchData(applicationId)
  const key = Object.keys(data.loanAutoRefiBkfPeople)[0]
  const { personalReferencePhone, personalReferencePhoneCode } =
    data.loanAutoRefiBkfPeople[key].attributes

  return `${personalReferencePhoneCode}${personalReferencePhone}`
}

export { fetchPhoneNumber }
